export const isPayingCustomer = (party: any) => {
  return Boolean(party?.billingDetails?.subscriptionPlan);
};
